import MainLayout from '../layouts/main';
import StudentQuestions from './student-questions';

function StudentQuestionsPage() {
  return (
    <MainLayout title={STUDENT_QUESTIONS_PAGE_TITLE}>
      <StudentQuestions />
    </MainLayout>
  );
}

export const STUDENT_QUESTIONS_PAGE_TITLE = 'غلط نامه';

export default StudentQuestionsPage;
